<template>
  <div
    :class="isMobile ? 'createAccount mobile_createAccount' : 'createAccount'"
  >
    <div :class="isMobile ? 'title mobileTitle' : 'title'">创建账户</div>
    <el-form
      ref="ruleForm"
      label-position="top"
      label-width="80px"
      :model="form"
    >
      <el-form-item prop="name" label="姓名">
        <el-input
          id="input1"
          @click.native="inputClick('input1')"
          v-model="form.name"
        ></el-input>
      </el-form-item>
      <el-form-item prop="mobilePhone" label="手机号码">
        <el-input
          maxlength="11"
          id="input2"
          @click.native="inputClick('input2')"
          v-model="form.mobilePhone"
        ></el-input>
      </el-form-item>
      <el-form-item prop="code" label="验证码">
        <el-input
          id="input3"
          @click.native="inputClick('input3')"
          v-model="form.code"
        >
          <template slot="append"
            ><div v-show="!showCountDown" class="codeLabel" @click="getCode">
              获取验证码
            </div>
            <div class="codeLabel" v-show="showCountDown">
              {{ countDown }}s
            </div></template
          >
        </el-input>
      </el-form-item>
      <el-form-item prop="password" label="登录密码">
        <el-input
          id="input4"
          @click.native="inputClick('input4')"
          show-password
          v-model="form.password"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div class="terms">
          <el-checkbox v-model="checked"></el-checkbox>
          <div class="son">
            创建微仓账户，即表示我了解并同意微仓的<span class="link"
              >《隐私声明》</span
            >和<span class="link">《使用条款》</span>
          </div>
        </div>
        <el-form-item>
          <el-button
            :disabled="
              !checked ||
                !form.name ||
                !form.mobilePhone ||
                !form.password ||
                !form.code
            "
            class="submit"
            @click="submitForm('ruleForm')"
            >创建账户</el-button
          >
        </el-form-item>
      </el-form-item>
    </el-form>
    <el-button @click="handleCancel" class="cancel">取消</el-button>
  </div>
</template>
<script>
var timeId;
import { apiRegister, apiLogin, apiSendCode } from "../../api/index";
import toast from "../../utils/toast";
export default {
  data() {
    return {
      form: {
        name: "",
        mobilePhone: "",
        password: "",
        code: ""
      },

      checked: false,
      countDown: 60,
      showCountDown: false
    };
  },
  computed: {
    isMobile: function() {
      return this.$store.state.isMobile;
    }
  },
  methods: {
    inputClick(value) {
      setTimeout(function() {
        document.getElementById(value).scrollIntoView(false);
      }, 200);
    },
    getCode() {
      // apiRegister(this.form).then(res => {
      //       window.open(
      //       `${process.env.VUE_APP_PROJECT_URL}?token=N1SWvvg54MkkwDr1Qo2Pog==&account=15136179457&password=123456`
      //     );
      //     this.$router.go(-2);
      // });
      // if(this.$route.query.free){

      // window.open(
      //   `${process.env.VUE_APP_PROJECT_URL}?token=N1SWvvg54MkkwDr1Qo2Pog==&account=15136179457&password=123456`
      // );
      // }
      // let pattern = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      // if (!pattern.test(this.form.mobilePhone)) {
      //   toast("请填写正确的手机号码", "error");
      //   return;
      // }
      apiSendCode(this.form.mobilePhone).then(res => {
        if (res.success) {
          clearInterval(timeId);
          this.showCountDown = true;
          timeId = setInterval(() => {
            this.countDown = this.countDown - 1;
            if (this.countDown < 1) {
              this.countDown = 60;
              this.showCountDown = false;
              clearInterval(timeId);
            }
          }, 1000);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.checked) {
            toast("请勾选同意创建微仓账户", "error");
            return;
          }

          apiRegister(this.form).then(res => {
            if (res.success) {
              toast("注册成功", "success");
              apiLogin({
                mobilePhone: this.form.mobilePhone,
                password: this.form.password
              }).then(res => {
                if (res.success) {
                  res.data.mobilePassword = this.form.password;
                  this.$store.commit("edit_user", res.data);
                  let userName = sessionStorage.getItem("user");

                  setTimeout(() => {
                    if (this.$route.query.free) {
                      let {
                        mobilePhone,
                        accessToken,
                        mobilePassword
                      } = JSON.parse(userName);
                      // console.log(JSON.parse(userName));
                      window.open(
                        `${process.env.VUE_APP_PROJECT_URL}?token=${accessToken}&account=${mobilePhone}&password=${mobilePassword}`
                      );
                    }
                    this.$router.go(-2);
                  }, 2000);
                }
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.$store.commit("edit_backgroundColor", "#3e3e3e");
    if (this.isMobile) {
      this.$store.commit("edit_showTop", false);
    }
  },
  destroyed() {
    clearInterval(timeId);
    this.$store.commit("edit_backgroundColor", "rgba(0, 0, 0, 1)");
  }
};
</script>

<style lang="less">
.createAccount {
  max-width: 430px;
  margin: 0 auto;
  padding-top: 116px;
  .el-input-group__append {
    background-color: #f6f6f6;
    width: 110px;
    border: none;
    position: relative;
    .codeLabel {
      padding-left: 20px;
      line-height: 28px;
      border-left: 1px solid rgba(216, 216, 216, 1);
      text-align: center;
      cursor: pointer;
    }
  }
  input {
    background-color: #f6f6f6;
    border: none;
  }

  .title {
    font-size: 34px;
  }
  .mobileTitle {
    font-size: 0.32rem;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }
  .el-form-item__label {
    padding: 0;
  }
  .submit {
    width: 100%;
    color: #fff;
    background: #fc9900;
    margin-top: 10px;
    border: none;
  }
  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    width: 100%;
    color: #fff;
    background: #fc9900;
    margin-top: 10px;
    border: none;
    opacity: 0.5;
  }
  .cancel {
    width: 100%;
    background: #f6f6f6;
    border: none;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fc9900;
    border-color: #fc9900;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #fc9900;
  }
  .el-checkbox__inner:hover {
    border-color: #fc9900;
  }
  .terms {
    line-height: 20px;
    display: flex;
    .son {
      flex: 1;
      padding-left: 8px;
      .link {
        color: #ff9300;
        cursor: pointer;
      }
    }
  }
}
.mobile_createAccount {
  padding: 1.22rem 0.64rem 0.64rem;
  margin: 0 auto;
}
</style>
